/* eslint-disable react/jsx-key */
import React, { Component, createRef } from "react";
import SubHeader from "../Components/SubHeader";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import queryString from "query-string";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader";
import "../Styles/emlak-genel.css";

export default class Ilanlar extends Component {
  componentDidUpdate(prevProps, prevState) {
    if (prevState.filter !== this.state.filter) {
      this.getIlan();
    }
  }

  pagination(pageNumber) {
    sessionStorage.setItem("ilanlar_page", pageNumber);
    this.setState({ page: pageNumber }, () => {
      this.getIlan(pageNumber);
    });
  }

  // Test verileri oluşturma fonksiyonu
  generateMockData = () => {
    return [
      {
        id: 1001,
        type: "Konut",
        title: "Merkezi Konumda Modern 3+1 Daire",
        price: "2.850.000",
        emlakDurumu: "Satılık",
        il: "İstanbul",
        ilce: "Kadıköy",
        mahalle: "Fenerbahçe",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: [
          "Oda Sayısı : 3 + 1",
          "Metrekare : 120",
          "Bulunduğu Kat : 2",
          "Asansör : Asansörlü",
        ],
      },
      {
        id: 1002,
        type: "Konut",
        title: "Deniz Manzaralı Lüks Villa",
        price: "12.500.000",
        emlakDurumu: "Satılık",
        il: "Antalya",
        ilce: "Muratpaşa",
        mahalle: "Lara",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: [
          "Oda Sayısı : 5 + 2",
          "Metrekare : 350",
          "Müstakil Villa",
          "Havuzlu",
        ],
      },
      {
        id: 1003,
        type: "Konut",
        title: "Üniversite Yakını Kiralık Daire",
        price: "8.500",
        emlakDurumu: "Kiralık",
        il: "Ankara",
        ilce: "Çankaya",
        mahalle: "Kızılay",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: [
          "Oda Sayısı : 2 + 1",
          "Metrekare : 85",
          "Bulunduğu Kat : 4",
          "Eşyalı",
        ],
      },
      {
        id: 1004,
        type: "Arsa",
        title: "Yatırımlık İmarlı Arsa",
        price: "1.200.000",
        emlakDurumu: "Satılık",
        il: "İzmir",
        ilce: "Bornova",
        mahalle: "Erzene",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: ["Metrekare : 500", "İmarlı", "Köşe Parsel"],
      },
      {
        id: 1005,
        type: "İşyeri",
        title: "AVM İçinde Kiralık Dükkan",
        price: "15.000",
        emlakDurumu: "Kiralık",
        il: "Bursa",
        ilce: "Nilüfer",
        mahalle: "Görükle",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: ["Metrekare : 45", "Vitrinli", "Yoğun Geçiş"],
      },
      {
        id: 1006,
        type: "Konut",
        title: "Bahçeli Müstakil Ev",
        price: "4.200.000",
        emlakDurumu: "Satılık",
        il: "Eskişehir",
        ilce: "Tepebaşı",
        mahalle: "Şirintepe",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: [
          "Oda Sayısı : 4 + 1",
          "Metrekare : 180",
          "Bahçeli",
          "Garajlı",
        ],
      },
      {
        id: 1007,
        type: "Konut",
        title: "Yeni Binada Kiralık Stüdyo",
        price: "5.500",
        emlakDurumu: "Kiralık",
        il: "Eskişehir",
        ilce: "Odunpazarı",
        mahalle: "Gültepe",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: [
          "Oda Sayısı : 1 + 0",
          "Metrekare : 35",
          "Yeni Bina",
          "Eşyalı",
        ],
      },
      {
        id: 1008,
        type: "Tarla",
        title: "Suya Yakın Tarım Arazisi",
        price: "850.000",
        emlakDurumu: "Satılık",
        il: "Konya",
        ilce: "Selçuklu",
        mahalle: "Sille",
        image: ["https://placehold.co/300x200"],
        typicalFeatures: ["Metrekare : 5000", "Sulu", "Yol Kenarı"],
      },
    ];
  };

  // Gelişmiş arama ve filtreleme fonksiyonu
  applyAdvancedFilters = () => {
    let filtered = [...this.state.mockData];

    if (this.state.advancedSearchTerm.trim() !== "") {
      const searchTerm = this.state.advancedSearchTerm.toLowerCase();
      filtered = filtered.filter(
        (property) =>
          property.title.toLowerCase().includes(searchTerm) ||
          property.il.toLowerCase().includes(searchTerm) ||
          property.ilce.toLowerCase().includes(searchTerm) ||
          property.mahalle.toLowerCase().includes(searchTerm) ||
          property.id.toString().includes(searchTerm)
      );
    }

    if (this.state.advancedTypeFilter !== "all") {
      filtered = filtered.filter(
        (property) => property.type === this.state.advancedTypeFilter
      );
    }

    if (this.state.advancedMinPrice !== "") {
      const minPrice = parseInt(this.state.advancedMinPrice.replace(/\./g, ""));
      filtered = filtered.filter((property) => {
        const price = parseInt(property.price.replace(/\./g, ""));
        return price >= minPrice;
      });
    }

    if (this.state.advancedMaxPrice !== "") {
      const maxPrice = parseInt(this.state.advancedMaxPrice.replace(/\./g, ""));
      filtered = filtered.filter((property) => {
        const price = parseInt(property.price.replace(/\./g, ""));
        return price <= maxPrice;
      });
    }

    if (this.state.advancedStatusFilter !== "all") {
      filtered = filtered.filter(
        (property) => property.emlakDurumu === this.state.advancedStatusFilter
      );
    }

    if (this.state.advancedCityFilter !== "all") {
      filtered = filtered.filter(
        (property) => property.il === this.state.advancedCityFilter
      );
    }

    if (this.state.advancedDistrictFilter !== "all") {
      filtered = filtered.filter(
        (property) => property.ilce === this.state.advancedDistrictFilter
      );
    }

    if (this.state.advancedNeighborhoodFilter !== "all") {
      filtered = filtered.filter(
        (property) => property.mahalle === this.state.advancedNeighborhoodFilter
      );
    }

    if (this.state.advancedIdFilter !== "") {
      filtered = filtered.filter((property) =>
        property.id.toString().includes(this.state.advancedIdFilter)
      );
    }

    this.setState({
      advancedSearchResults: filtered,
      isAdvancedSearchActive: true,
    });
  };

  // Orijinal filtreleme fonksiyonu

  // Sıralama fonksiyonu
  sortProperties = (sortType) => {
    let sorted = [...this.state.properties];

    switch (sortType) {
      case "price-asc":
        sorted.sort(
          (a, b) =>
            parseInt(a.price.replace(/\./g, "")) -
            parseInt(b.price.replace(/\./g, ""))
        );
        break;
      case "price-desc":
        sorted.sort(
          (a, b) =>
            parseInt(b.price.replace(/\./g, "")) -
            parseInt(a.price.replace(/\./g, ""))
        );
        break;
      case "newest":
        sorted.sort((a, b) => b.id - a.id);
        break;
      case "oldest":
        sorted.sort((a, b) => a.id - b.id);
        break;
      default:
        break;
    }

    this.setState({ properties: sorted, sortFilter: sortType });
  };

  // Benzersiz değerleri alma fonksiyonları
  getAdvancedUniqueValues = (key) => {
    return [...new Set(this.state.mockData.map((item) => item[key]))].sort();
  };

  getUniqueCities = () => {
    const cities = [...new Set(this.state.allProperties.map((p) => p.il))];
    return cities.sort();
  };

  getUniqueDistricts = () => {
    let properties = this.state.allProperties;
    if (this.state.cityFilter !== "all") {
      properties = properties.filter((p) => p.il === this.state.cityFilter);
    }
    const districts = [...new Set(properties.map((p) => p.ilce))];
    return districts.sort();
  };

  // Gelişmiş arama temizleme
  clearAdvancedSearch = () => {
    this.setState({
      advancedSearchTerm: "",
      advancedTypeFilter: "all",
      advancedMinPrice: "",
      advancedMaxPrice: "",
      advancedStatusFilter: "all",
      advancedCityFilter: "all",
      advancedDistrictFilter: "all",
      advancedNeighborhoodFilter: "all",
      advancedIdFilter: "",
      advancedSearchResults: [],
      isAdvancedSearchActive: false,
      showAdvancedFilters: false,
    });
  };

  properties = [];

  PropertyListings = () => {
    const dataToShow = this.state.isAdvancedSearchActive
      ? this.state.advancedSearchResults
      : this.state.properties;

    return (
      <div className="row properties-box">
        {dataToShow.length === 0 ? (
          <div className="col-12 text-center">
            <div style={{ padding: "60px 20px", color: "#666" }}>
              <div
                style={{
                  fontSize: "64px",
                  marginBottom: "20px",
                  color: "#6c757d",
                }}
              >
                🔍
              </div>
              <h3
                style={{
                  marginBottom: "15px",
                  fontSize: "28px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                {this.state.isAdvancedSearchActive
                  ? "Arama Sonucu Bulunamadı"
                  : "Aradığınız kriterlere uygun ilan bulunamadı"}
              </h3>
              <p style={{ fontSize: "16px", color: "#666", lineHeight: "1.6" }}>
                {this.state.isAdvancedSearchActive
                  ? "Arama kriterlerinizi değiştirerek tekrar deneyin"
                  : "Farklı filtreler deneyebilir veya gelişmiş arama kullanabilirsiniz"}
              </p>
            </div>
          </div>
        ) : (
          dataToShow.map((property) => (
            <div
              key={property.id}
              className="col-lg-4 col-md-6 mb-30 properties-items adv"
            >
              <div
                className="item"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
                  transition: "all 0.4s ease",
                  background: "#fff",
                  border: "1px solid #f5f5f5",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  <Link to={`/ilan-detay?id=${property.id}`}>
                    <img
                      src={
                        this.state.isAdvancedSearchActive
                          ? property.image[0]
                          : `${process.env.REACT_APP_API_URL}/api/files/?filepath=${property.image[0]}`
                      }
                      alt={property.title}
                      style={{
                        width: "100%",
                        height: "220px",
                        objectFit: "cover",
                        transition: "transform 0.4s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.transform = "scale(1.05)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    />
                  </Link>

                  <span
                    className="category"
                    style={{
                      position: "absolute",
                      bottom: "15px",
                      left: "15px",
                      background: "#2c3e50",
                      color: "white",
                      padding: "10px 20px",
                      borderRadius: "30px",
                      fontSize: "12px",
                      fontWeight: "600",
                      border: "2px solid white",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    }}
                  >
                    {property.emlakDurumu} {property.type}
                  </span>
                </div>

                <div style={{ padding: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <h6
                      style={{
                        padding: "8px 0",
                        margin: "0 0 0 0",
                        alignSelf: "flex-start",
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "#3498db",
                        textShadow: "0 2px 4px rgba(231,76,60,0.1)",
                      }}
                    >
                      ₺{property.price}
                    </h6>

                    <h4
                      style={{
                        fontSize: "16px",
                        marginBottom: "5",
                        lineHeight: "1.4",
                        overflow: "hidden",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                      }}
                    >
                      <Link
                        to={`/ilan-detay?id=${property.id}`}
                        style={{
                          color: "#2c3e50",
                          textDecoration: "none",
                          fontWeight: "600",
                          transition: "color 0.3s ease",
                        }}
                        onMouseOver={(e) => (e.target.style.color = "#3498db")}
                        onMouseOut={(e) => (e.target.style.color = "#2c3e50")}
                      >
                        {property.title}
                      </Link>
                    </h4>
                  </div>

                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: "0 0 25px 0",
                      fontSize: "13px",
                      color: "#666",
                    }}
                  >
                    {property.typicalFeatures
                      ? Array.isArray(property.typicalFeatures)
                        ? property.typicalFeatures
                            .slice(0, 3)
                            .map((item, index) => {
                              const parts = item.split(":");
                              return parts.length === 2 ? (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: "8px",
                                    padding: "6px 0",
                                    borderBottom: "1px solid #f8f9fa",
                                  }}
                                >
                                  <span
                                    style={{ fontWeight: "600", color: "#555" }}
                                  >
                                    {parts[0]}
                                  </span>{" "}
                                  :
                                  <span
                                    style={{
                                      color: "#3498db",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {parts[1]}
                                  </span>
                                </li>
                              ) : (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: "8px",
                                    padding: "6px 0",
                                  }}
                                >
                                  {item}
                                </li>
                              );
                            })
                        : property.typicalFeatures
                            .split(",")
                            .slice(0, 3)
                            .map((item, index) => {
                              const parts = item.split(":");

                              return parts.length === 2 ? (
                                <li
                                  key={index}
                                  style={{
                                    marginBottom: "8px",
                                    padding: "6px 0",
                                    borderBottom: "1px solid #f8f9fa",
                                  }}
                                >
                                  <span
                                    style={{ fontWeight: "600", color: "#555" }}
                                  >
                                    {parts[0]}
                                  </span>{" "}
                                  :
                                  <span
                                    style={{
                                      color: "#3498db",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {parts[1]}
                                  </span>
                                </li>
                              ) : null;
                            })
                      : null}

                    <li
                      style={{
                        marginTop: "5px",
                        marginBottom: "5px",
                        fontSize: "13px",
                        lineHeight: "1.6",
                      }}
                    >
                      <span style={{ color: "#e74c3c", fontSize: "14px" }}>
                        📍
                      </span>
                      <span style={{ fontWeight: "600", color: "#555" }}>
                        {" "}
                        Konum :
                      </span>
                      <span
                        style={{ color: "#666" }}
                      >{` ${property.il}  ${property.ilce}  ${property.mahalle}`}</span>
                    </li>
                    <li
                      style={{
                        marginTop: "5px",
                        marginBottom: "5px",
                        fontSize: "13px",
                        lineHeight: "1.6",
                      }}
                    >
                      <span style={{ fontWeight: "600", color: "#555" }}>
                        {" "}
                        İlan Numarası :
                      </span>
                      <span style={{ color: "#666" }}>{` ${property.id}`}</span>
                    </li>
                  </ul>

                  <div className="main-button">
                    <Link
                      to={`/ilan-detay?id=${property.id}`}
                      style={{
                        display: "block",
                        background: "#1e1e1e",
                        color: "white",
                        borderRadius: "30px",
                        textDecoration: "none",
                        textAlign: "center",
                        fontWeight: "600",
                        fontSize: "14px",
                        transition: "all 0.3s ease",
                        boxShadow: "0 4px 10px rgba(18, 37, 50, 0.4)",
                        border: "none",
                        transform: "scale(1)",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.background = "#2c2c2c";
                        e.target.style.transform =
                          "translateY(-4px) scale(1.03)";
                        e.target.style.boxShadow =
                          "0 8px 16px rgba(18, 37, 50, 0.6)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.background = "#1e1e1e";
                        e.target.style.transform = "translateY(0) scale(1)";
                        e.target.style.boxShadow =
                          "0 4px 10px rgba(18, 37, 50, 0.4)";
                      }}
                      onMouseDown={(e) => {
                        e.target.style.transform =
                          "translateY(1px) scale(0.98)";
                      }}
                      onMouseUp={(e) => {
                        e.target.style.transform =
                          "translateY(-2px) scale(1.02)";
                      }}
                    >
                      İlanı İncele
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  activeCategories = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ilan/get-active-types`, {
      method: "POST",
      body: JSON.stringify({}),
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((err) => {
            alert("Uyarı.");
            return Promise.resolve();
          });
        }
        return response.json();
      })
      .then((result) => {
        if (result["m"] == "basarili") {
          this.setState({ activeCategoriesList: result["data"] });
        }
      })
      .catch((e) => {
        alert("Bir hata oluştu.");
      });
  };

  // Frontend güncellemeleri - Ilanlar.js dosyasındaki değişiklikler

  // Constructor'a eklenecek state değişiklikleri
  constructor(props) {
    super(props);
    this.pagination = this.pagination.bind(this);
    this.getIlan = this.getIlan.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.state = {
      properties: [],
      allProperties: [],
      page: 1,
      activeCategoriesList: [],
      kayitSayisi: 0,
      filter: "Tümü",
      priceFilter: "all",
      statusFilter: "all",
      cityFilter: "all",
      districtFilter: "all",
      searchedId: "all",
      roomFilter: "all",
      searchFilter: "",
      sortFilter: "newest",
      showAdvancedFilters: false,
      isAdvancedSearchActive: false,
      advancedSearchTerm: "",
      advancedTypeFilter: "all",
      advancedMinPrice: "",
      advancedMaxPrice: "",
      advancedStatusFilter: "all",
      advancedCityFilter: "all",
      advancedDistrictFilter: "all",
      advancedNeighborhoodFilter: "all",
      advancedIdFilter: "",
      advancedSearchResults: [],
      mockData: [],
      // Yeni eklemeler
      filtersCollapsed: true,
      cities: [],
      districts: [],
      isLoading: false,
    };
    this.sectionRef = createRef();
  }

  // getIlan fonksiyonunu güncelle
  getIlan(page) {
    if (page == undefined) {
      page = 1;
    }

    this.setState({ isLoading: true });

    // Filtreleri URL parametresi olarak ekle
    const params = new URLSearchParams({
      p: page,
      filter: this.state.filter || "Tümü",
      priceFilter: this.state.priceFilter || "all",
      statusFilter: this.state.statusFilter || "all",
      cityFilter: this.state.cityFilter || "all",
      districtFilter: this.state.districtFilter || "all",
      searchedId: this.state.searchedId || "all",
      roomFilter: this.state.roomFilter || "all",
      searchFilter: this.state.searchFilter || "",
      sortFilter: this.state.sortFilter || "newest",
    });

    fetch(
      `${process.env.REACT_APP_API_URL}/api/ilan/get-preview-with-filters?${params}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Veri alınamadı.");
        }
        return response.json();
      })
      .then((data) => {
        console.log("gelen filtrelenmiş data: ", data);

        if (data.m === "basarili") {
          this.setState({
            properties: data.data,
            allProperties: data.data,
            kayitSayisi: data.kayitSayisi,
            isLoading: false,
          });
        } else {
          console.error("API Error:", data.m);
          this.setState({ isLoading: false });
        }
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
        this.setState({ isLoading: false });
      });
  }

  // Şehirleri yükle
  loadCities = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ilan/get-cities`)
      .then((response) => response.json())
      .then((data) => {
        if (data.m === "basarili") {
          this.setState({ cities: data.data });
        }
      })
      .catch((err) => console.error("Cities load error:", err));
  };

  // İlçeleri yükle
  loadDistricts = (selectedCity = null) => {
    const city = selectedCity || this.state.cityFilter;
    const params = city && city !== "all" ? `?city=${city}` : "";

    fetch(`${process.env.REACT_APP_API_URL}/api/ilan/get-districts${params}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.m === "basarili") {
          this.setState({ districts: data.data });
        }
      })
      .catch((err) => console.error("Districts load error:", err));
  };

  // Orijinal applyFilters fonksiyonunu güncelle
  applyFilters = () => {
    // Sayfa numarasını 1'e sıfırla
    this.setState({ page: 1 }, () => {
      this.getIlan(1);
    });
  };

  // Yeni filter change handlers
  handleFilterChange = (filterType, value) => {
    const newState = { [filterType]: value };

    // Şehir değiştiğinde ilçeleri sıfırla
    if (filterType === "cityFilter") {
      newState.districtFilter = "all";
      this.loadDistricts(value);
    }

    this.setState(newState, () => {
      this.applyFilters();
    });
  };

  // Arama için debounced fonksiyon
  handleSearchChange = (value) => {
    this.setState({ searchFilter: value });

    // Debounce search
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.applyFilters();
    }, 500);
  };

  // Sıralama değiştir
  handleSortChange = (sortType) => {
    this.setState({ sortFilter: sortType }, () => {
      this.applyFilters();
    });
  };

  // componentDidMount'u güncelle
  componentDidMount() {
    const savedPage = sessionStorage.getItem("ilanlar_page");
    const parsedPage = savedPage ? parseInt(savedPage) : 1;

    this.setState(
      {
        page: parsedPage,
        mockData: this.generateMockData(),
      },
      () => {
        this.getIlan(parsedPage);
        this.loadCities();
        this.loadDistricts();
      }
    );

    this.activeCategories();
  }

  // Cleanup
  componentWillUnmount() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }

  handleScroll = () => {
    if (this.sectionRef.current) {
      this.sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  render() {
    return (
      <>
        <Loader />
        <SubHeader />
        <Header />

        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <span className="breadcrumb">
                  <a href="#">İlanlar</a>
                </span>
                <h3>İlanlarımız</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="section properties" ref={this.sectionRef}>
          <div className="container">
            {/* Gelişmiş Arama Paneli */}

            {/* Ana Filtreleme Paneli */}
            <div className="row mb-4">
              <div className="col-12">
                <div
                  style={{
                    background: "white",
                    borderRadius: "15px",
                    padding: "25px",
                    marginBottom: "20px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      this.setState({
                        filtersCollapsed: !this.state.filtersCollapsed,
                      })
                    }
                  >
                    <h6
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: "#2c3e50",
                        margin: "0",
                      }}
                    >
                      🔍 Hızlı Filtreler
                    </h6>
                    <span
                      style={{
                        fontSize: "18px",
                        color: "#2c3e50",
                        transition: "transform 0.3s ease",
                        transform: this.state.filtersCollapsed
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      }}
                    >
                      <i className="fas fa-chevron-down" aria-hidden="true"></i>
                    </span>
                  </div>

                  {!this.state.filtersCollapsed && (
                    <>
                      <div className="row">
                        {/* Kategori Filtresi */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Kategori
                          </label>
                          <select
                            className="form-control"
                            value={this.state.filter}
                            onChange={(e) =>
                              this.handleFilterChange("filter", e.target.value)
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="Tümü">Tüm Kategoriler</option>
                            {this.state.activeCategoriesList.map((category) => (
                              <option key={category.type} value={category.type}>
                                {category.type}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* Durum Filtresi */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Durum
                          </label>
                          <select
                            className="form-control"
                            value={this.state.statusFilter}
                            onChange={(e) =>
                              this.handleFilterChange(
                                "statusFilter",
                                e.target.value
                              )
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="all">Tüm Durumlar</option>
                            <option value="Satılık">Satılık</option>
                            <option value="Kiralık">Kiralık</option>
                            <option value="Devren Satılık">
                              Devren Satılık
                            </option>
                            <option value="Devren Kiralık">
                              Devren Kiralık
                            </option>
                          </select>
                        </div>

                        {/* Fiyat Filtresi */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Fiyat Aralığı
                          </label>
                          <select
                            className="form-control"
                            value={this.state.priceFilter}
                            onChange={(e) =>
                              this.handleFilterChange(
                                "priceFilter",
                                e.target.value
                              )
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="all">Tüm Fiyatlar</option>
                            <option value="0-500000">0 - 500.000 ₺</option>
                            <option value="500000-1000000">
                              500.000 - 1.000.000 ₺
                            </option>
                            <option value="1000000-2000000">
                              1.000.000 - 2.000.000 ₺
                            </option>
                            <option value="2000000-5000000">
                              2.000.000 - 5.000.000 ₺
                            </option>
                            <option value="5000000-10000000">
                              5.000.000 - 10.000.000 ₺
                            </option>
                            <option value="10000000">10.000.000 ₺ +</option>
                          </select>
                        </div>

                        {/* Şehir Filtresi */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Şehir
                          </label>
                          <select
                            className="form-control"
                            value={this.state.cityFilter}
                            onChange={(e) =>
                              this.handleFilterChange(
                                "cityFilter",
                                e.target.value
                              )
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="all">Tüm Şehirler</option>
                            {this.state.cities.map((city) => (
                              <option key={city} value={city}>
                                {city}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* İlçe Filtresi */}
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            İlçe
                          </label>
                          <select
                            className="form-control"
                            value={this.state.districtFilter}
                            onChange={(e) =>
                              this.handleFilterChange(
                                "districtFilter",
                                e.target.value
                              )
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="all">Tüm İlçeler</option>
                            {this.state.districts.map((district) => (
                              <option key={district} value={district}>
                                {district}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-lg-2 col-md-4 col-sm-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            İlan Numarası:
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={
                              this.state.searchedId == "all"
                                ? ""
                                : this.state.searchedId
                            }
                            onChange={(e) =>
                              this.handleFilterChange(
                                "searchedId",
                                e.target.value
                              )
                            }
                            placeholder="İlan numarası girin..."
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          />
                        </div>
                      </div>

                      {/* Arama ve Sıralama */}
                      <div className="row mt-3">
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Arama
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="İlan başlığı, şehir, ilçe, mahalle ara..."
                            value={this.state.searchFilter}
                            onChange={(e) =>
                              this.handleSearchChange(e.target.value)
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          />
                        </div>

                        <div className="col-lg-3 col-md-3 mb-3">
                          <label
                            style={{
                              fontSize: "13px",
                              fontWeight: "600",
                              color: "#555",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Sıralama
                          </label>
                          <select
                            className="form-control"
                            value={this.state.sortFilter}
                            onChange={(e) =>
                              this.handleSortChange(e.target.value)
                            }
                            style={{
                              fontSize: "14px",
                              padding: "10px 15px",
                              borderRadius: "8px",
                              border: "2px solid #dee2e6",
                              background: "white",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <option value="newest">En Yeni</option>
                            <option value="oldest">En Eski</option>
                            <option value="price-asc">
                              Fiyat (Düşük-Yüksek)
                            </option>
                            <option value="price-desc">
                              Fiyat (Yüksek-Düşük)
                            </option>
                          </select>
                        </div>

                        <div className="col-lg-3 col-md-3 mb-3 d-flex align-items-end">
                          <button
                            className="btn"
                            onClick={() => {
                              this.setState(
                                {
                                  filter: "Tümü",
                                  priceFilter: "all",
                                  statusFilter: "all",
                                  cityFilter: "all",
                                  districtFilter: "all",
                                  searchedId: "all",
                                  searchFilter: "",
                                  sortFilter: "newest",
                                },
                                () => {
                                  this.applyFilters();
                                }
                              );
                            }}
                            style={{
                              background: "#e74c3c",
                              color: "white",
                              borderRadius: "8px",
                              fontSize: "14px",
                              padding: "10px 20px",
                              fontWeight: "600",
                              border: "none",
                              width: "100%",
                              transition: "all 0.3s ease",
                            }}
                            onMouseOver={(e) => {
                              e.target.style.background = "#c0392b";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onMouseOut={(e) => {
                              e.target.style.background = "#e74c3c";
                              e.target.style.transform = "translateY(0)";
                            }}
                          >
                            🗑️ Filtreleri Temizle
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {/* Filtreleme Sonucu Bilgisi - Her zaman görünür */}
                  <div className="row mt-3">
                    <div className="col-12">
                      <div
                        style={{
                          background: "#f8f9fa",
                          padding: "15px 20px",
                          borderRadius: "10px",
                          border: "2px solid #e9ecef",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#495057",
                            fontWeight: "600",
                          }}
                        >
                          📊 {this.state.kayitSayisi} ilan bulundu
                          {this.state.isLoading && (
                            <span
                              style={{ marginLeft: "10px", color: "#6c757d" }}
                            >
                              (Yükleniyor...)
                            </span>
                          )}
                        </div>
                        <div style={{ fontSize: "13px", color: "#6c757d" }}>
                          Sayfa {this.state.page} /{" "}
                          {Math.max(1, Math.ceil(this.state.kayitSayisi / 9))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sonuç Başlığı */}
            {this.state.isAdvancedSearchActive && (
              <div className="row mb-4">
                <div className="col-12">
                  <div
                    style={{
                      background: "white",
                      borderRadius: "16px",
                      padding: "25px",
                      color: "#2c3e50",
                      position: "relative",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                      border: "2px solid #3498db",
                    }}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6
                          style={{
                            fontSize: "22px",
                            fontWeight: "bold",
                            color: "#2c3e50",
                            marginBottom: "10px",
                          }}
                        >
                          🎯 Arama Sonuçları
                        </h6>
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#6c757d",
                            margin: "0",
                            lineHeight: "1.4",
                          }}
                        >
                          Test verileri kullanılarak{" "}
                          <strong style={{ color: "#3498db" }}>
                            {this.state.advancedSearchResults.length}
                          </strong>{" "}
                          ilan gösteriliyor.
                          {this.state.advancedSearchTerm && (
                            <>
                              <br />
                              {/* 📝 " */}
                              <strong style={{ color: "#e74c3c" }}>
                                {this.state.advancedSearchTerm}
                              </strong>
                              {/* " araması için sonuçlar. */}
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row properties-box">
              <this.PropertyListings />
            </div>

            {/* Pagination (sadece normal mod için) */}
            {!this.state.isAdvancedSearchActive && (
              <div className="row">
                <div className="col-lg-12">
                  <ul className="pagination">
                    {this.state.kayitSayisi !== 0 && this.state.page !== 1 ? (
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            this.handleScroll();
                            this.pagination(1);
                          }}
                        >
                          {"<<"}
                        </a>
                      </li>
                    ) : (
                      <></>
                    )}
                    {this.state.kayitSayisi !== 0 &&
                      Array.from(
                        {
                          length: Math.max(
                            1,
                            Math.ceil(this.state.kayitSayisi / 9)
                          ),
                        },
                        (_, index) => index + 1
                      ).map((num) => (
                        <li key={num}>
                          <a
                            className={
                              this.state.page === num ? "is_active" : ""
                            }
                            onClick={() => {
                              this.handleScroll();
                              this.pagination(num);
                            }}
                          >
                            {num}
                          </a>
                        </li>
                      ))}

                    {Math.max(1, Math.ceil(this.state.kayitSayisi / 9)) !==
                      this.state.page && (
                      <li>
                        <a
                          href="#"
                          onClick={() => {
                            this.handleScroll();
                            this.pagination(
                              Math.max(1, Math.ceil(this.state.kayitSayisi / 9))
                            );
                          }}
                        >
                          {">>"}
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>

        <Footer />

        <script src="vendor/jquery/jquery.min.js"></script>
        <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
        <script src="assets/js/isotope.min.js"></script>
        <script src="assets/js/owl-carousel.js"></script>
        <script src="assets/js/counter.js"></script>
        <script src="assets/js/custom.js"></script>
      </>
    );
  }
}
